import {staffCanVisit} from '../utils/dashboardNavigation.mjs';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import BrandedLoader from '../components/BrandedLoader';

const ProtectedRoute = ({ roles }) => {
  const location = useLocation();
  const { user, hydrated } = useSelector((state) => state.auth);

  if (!hydrated) {
    return <BrandedLoader message="Preparing your dashboard..." />;
  }

  if (!user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  if(user.role==='SHOP_OPERATOR' && location.pathname.startsWith('/dashboard') && !staffCanVisit(location.pathname,location.search,user.staffModules||[]))return <Navigate to="/dashboard/workspace" replace state={{accessRemoved:true}}/>;

  const requiresProfile = user.role === 'SHOP_OWNER' && !user.profileCompleted;
  const isProfileRoute = location.pathname.startsWith('/dashboard/profile');
  const isModulePlanRoute = location.pathname.startsWith('/dashboard/settings');

  if (requiresProfile && !isProfileRoute && !isModulePlanRoute) {
    return <Navigate to="/dashboard/profile" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
